// extracted by mini-css-extract-plugin
module.exports = {"title":"terms_title__EnRgr","termsContainer":"terms_termsContainer__qBb89","contentContainer":"terms_contentContainer__pc_6q"};